import './styles.scss'
import React from 'react'
import { Modal } from 'reactstrap'
import { getStaticImage } from 'utils/statics'

// eslint-disable-next-line react/display-name
export default (props) => {
  const { id, isOpen, toggle, backdrop, header, body, footer, keyboard, isOpenContainer, contentClassName } = props

  return (
    <Modal centered id={id} isOpen={isOpen} toggle={toggle} className={''} contentClassName={`modal-content-channels ${contentClassName ? contentClassName : ''} ${isOpenContainer && isOpenContainer.resources ? 'overflow-modal' : ''}`} backdrop={backdrop} keyboard={keyboard}>
      <span className='close-modal' onClick={toggle}>
        <img src={getStaticImage('/icons/orange-brand/icon-close.svg')} alt='Close'/>
      </span>
      {header &&
        <div className='modal-wrapper-header'>
          {header}
        </div>
      }
      {body &&
        <div className ='modal-wrapper-body'>
          {body}
        </div>
      }
      {footer &&
        <div className='modal-wrapper-footer'>
          {footer}
        </div>
      }
    </Modal>
  )
}
